export const CHECK = "CHECK";
export const SUBMIT = "Submit";
export const USERNAME = "USERNAME";
export const SAVE_N_CLOSE = "SAVE & CLOSE";
export const USERNAME_VERIFIED = "usernameVerified";
export const I_HAVE_MY_IRCTC_PASSWORD_FOR_THIS_USERNAME = 'I have my IRCTC password for this username';
